import { useRouter } from "next/router";
import { useEffect } from "react";

interface UseRedirectIfProps {
  condition: boolean;
  href: string;
  isExternal?: boolean;
}
export const useRedirectIf = (props: UseRedirectIfProps) => {
  const router = useRouter();
  useEffect(() => {
    if (props.condition) {
      if (props.isExternal ?? false) {
        window.location.replace(props.href);
      } else {
        router.push(props.href);
      }
    }
  }, [props, router]);
};
